'use strict';
var showimg='';
var get_reviews = ($this)=>{
    let item_id = $this.data('item-id');
    let venueId = $this.data('venue-id');
    let itemUpc = $this.data('upc');
    let itemSku = $this.data('sku');
    console.log("in get_reviews....", item_id, venueId);

    let data = {
        item_id: item_id,
        venue_id: $('#venue-id').text().trim() || venueId,
        sku: itemSku,
        upc: itemUpc
    }
    $.ajax({
        url: "/menu-item/reviews",
        type: "POST",
        contentType: "application/json; charset=utf-8",
        data: JSON.stringify(data),
        success: function (res) {
           return  userimg(res);
           
           //return render_item_reviews(res)
        },
        error: function (e) {
         
        }
    })
}

$( "#modal-item-reviews" ).on('shown.bs.modal', function(){
    $('html').css({'overflow': 'hidden'})
});

$( "#modal-item-reviews" ).on('hidden.bs.modal', function(){
    $('html').css({'overflow': 'auto'})
});
// 

function remove_review_photo(elem){
    elem = $(elem)
    let data = {
        review_id: elem.data('review-id'),
        review_img: elem.data('review-img'),
        venue_id: $('#venueId').val()
    }
    $.ajax({
        url: "/menu-item/remove-review-img",
        type: "POST",
        contentType: "application/json; charset=utf-8",
        data: JSON.stringify(data),
        success: function (res) {
            $(`#item-review-${data.review_id}`).find('.review-photo').attr('src', '/images/tempfoodnotext.png')
            $('.remove-review-photo').popover('hide')
            $(`#item-review-${data.review_id}`).find('.remove-review-photo').remove()
            $(`img[src="${data.review_img}"]`).remove()
            return true
        },
        error: function (e) {
            return toastr.error("Failed! Please try again.");
        }
    })
}
function cancel_review_photo(elem){
    let review_id =  $(elem).data('review-id')
    $(`#item-review-${review_id}`).find('.remove-review-photo').click()
}
// 

function remove_this_review(elem){
    var result = confirm("Are you sure to delete this rating?");
    if(result){
    console.log("Deleted")
    
        elem = $(elem)
        let data = {
            review_id: elem.data('review-id'),
            venue_id: $('#venueId').val()
        }
        $.ajax({
            url: "/menu-item/remove-this-review",
            type: "POST",
            contentType: "application/json; charset=utf-8",
            data: JSON.stringify(data),
            success: function (res) {
                $('.remove-this-review').popover('hide')
                $(`#item-review-${data.review_id}`).parent().remove()
                return true
            },
            error: function (e) {
                return toastr.error("Failed! Please try again.");
            }
        })
    }
}
function cancel_this_review(elem){
    let review_id =  $(elem).data('review-id')
    $(`#item-review-${review_id}`).find('.remove-this-review').click()
}
// 
  
function userimg(data){
    let userimgDataval = [];
    var newdata=[];
     
    $.ajax({
        url: "/menuitem/userimg",
        type: "POST",
        contentType: "application/json; charset=utf-8",
        data: JSON.stringify({"item":data.data}),
         success: function (res) {
            userimgDataval.push(res)
            return render_item_reviews(data,res)
         }
    });
}

function render_item_reviews(infor,res) {
   console.log("resdata===",res)
    let data = infor.data
    let platerate_admin = _.includes(infor.role, 'platerate_admin')
    let sale_person = _.includes(infor.role, 'sale_person')
    let item_addons = _.uniq(_.map(data, item => item.menuItemName || item.name))
    data = _.orderBy(data,['dateUpdated'],['desc']);
    let user_id = $('#userId').val() || $('#user-id').text()
    let html='';
    
    
    function render_comment(infor){
        let html = ``;
        _.forEach(infor, (item)=>{
            let date_time = moment(item.createdDate).format('MM/DD/YYYY hh:mm:ss');
            html += `
                <li class="list-group-item">
                    <div class="form-row">
                        <span>${item.userName}: ${item.comment}</span>
                        <span class="float-right" style="color: grey; font-size: 15px">${date_time}</span>
                    </div>
                </li>
            `;
        })
        html = `
            <ul class="list-group">
                ${html}
            </ul>   
        `;
        return html;
    }

    function showuserimgdata(userId) {
        let html = ``;
        console.log("res====,",res)
        if(res){
           _.forEach(res, (useritems)=>{
            console.log("userId===",userId);
            console.log("useritems===",useritems)
             if(useritems && useritems._id==userId){
                    html = `<img src="${useritems.profile.imageUrl ? useritems.profile.imageUrl :'/images/tempfoodnotext.png'}? " class="rounded-circle" style="width: 40px; height:40px;">`;
                
               }
            });
            
            return html;  
        }
    
    }
    function render_expert(infor, item_id){
      if(typeof infor ==="undefined") return '';
        let expert = {
            sweet: 'Sweet',
            salty: 'Salty',
            savory: 'Umami (meaty taste)',
            bitter: 'Bitter',
            sour: 'Sour',
            spicy: 'Spicy',
            presentation: 'Presentation',
            healthy: 'Healthy',
            quantity: 'Portion Size',
        }
        let expert_keys = _.keysIn(expert);
        let html = ``;
        let ex_set = false;
        _.forEach(expert_keys, (item)=>{
           let expertValue = expert[item];
           if(infor[expertValue] && Number(infor[expertValue]) > 0) ex_set = true;
           if(infor[item] && Number(infor[item]) > 0) ex_set = true;
           let value = infor[expertValue] || infor[item];
           if(value){
            html += `
                <div class="form-row col-md-4 col-sm-6">
                    <label class="col-sm-12 col-md-12 font-bold mb-1 pl-2" style="vertical-align: baseline; margin-top: 0px;">${expert[item]}</label>
                    <div class="col-sm-12 col-md-12" style="padding-left:25px;padding-right:25px;">
                        <div class="row">
                            <input class="my-expert-review" type="number" data-slider-min="0" data-slider-max="100" data-slider-step="5" data-slider-enabled="false" data-slider-value="${value}"/>
                        </div>
                        <div class="row p-1">
                            <span class="col-6 p-0 m-0">Low</span>
                            <span class="col-6 p-0 m-0 text-right">High</span>
                        </div>
                    </div>
                </div>
            `;
           }
        })
        if(!ex_set) return ['',''];
        html = `
            <div class="col-12 col-md-12 collapse" id="collapse-expert-${item_id}">
                    <div class="form-row review-margin-padding">
                        ${html}
                    </div>
            </div>
        `;
        let html_reviews =  `
        <div class="col-12 col-md-12">
            <a href="javascript:void(0)" style="color: green; font-weight: bold" data-toggle="collapse" data-target="#collapse-expert-${item_id}" aria-expanded="false" aria-controls="collapse-expert-${item_id}">
                View FlavorMatch reviews <i class="fa fa-chevron-down"></i>
            </a>
        </div>`;
        return [html, html_reviews];
    }
    function menu_breadcrumb(item){
     
      let breadcrumb = [];
     /*------fency treecode removed due to redesign--------*/
      if(item){
        breadcrumb.push(item.menuItemName,item.sectionName,item.menuName);
      }
      return breadcrumb.reverse().join(' > ');
    }
    let i = 0;
    _.forEach(data, (item)=>{
      i++
        let img = '/images/tempfoodnotext.png';
        let [html_expert, html_reviews]= render_expert(item.expertReview, item._id);
        if(_.size(item.imageUrls)) img = _.last(item.imageUrls).url;
        let date_time = moment(item.dateUpdated).format('MM/DD/YYYY hh:mm a');

        html += `
            <li class="list-group-item list-group-item-success item-addons-review" data-name="${item.menuItemName || item.name}" ${i > 3 ? `style="display:none;"`:``}>
                <div class="form-row" id="item-review-${item._id}">
                    <div class="col-sm-12 col-md-4 review-infor">
                        <img src="${img}" class="media-object review-photo">
                        ${ img != '/images/tempfoodnotext.png' && (user_id == item.userId || platerate_admin || sale_person) ? 
                            ` <div class="remove-review-photo" 
                                data-toggle="popover" 
                                data-placement="bottom"
                                data-content="<h4>Are you sure to delete this photo?</h4>
                                    <button class='btn btn-success' data-review-id='${item._id}' data-review-img='${img}' onclick='remove_review_photo(this)'>Ok</button>
                                    <button class='btn btn-danger' data-review-id='${item._id}' onclick='cancel_review_photo(this)'>Cancel</button>
                                " 
                                style="position: absolute; top: 90%; left: 50%; transform: translate(-50%, -50%); color: red">
                                    <i class="fa fa-times fa-2x" aria-hidden="true"></i>
                                </div>
                            `
                        : ''}
                    </div>
                    <div class="col-sm-12 col-md-8">
                        <div class="form-row form-group">
                            <div>${menu_breadcrumb(item)} ${item.type == 3 ? '> <b>' + item.name + '</b>' : ''}</div>
                        </div>
                        <div class="form-row">
                            <div class="item-reviews-star" data-value="${item.starRating}" data-userid="${item.userId}"></div> 
                        </div>
                        <div class="d-flex justify-content-between">
                            <div class="" style="font-size: 20px">
                                By <a href="/publicprofile/${item.userId}">
                                <span class="green">${item.userName}</span>
                                </a> on  <span class="green">${date_time}</span>
                            </div>
                            ${ (user_id == item.userId || platerate_admin || sale_person) ? 
                                `<div class="hvr-grow remove-this-review" 
                                    data-toggle="popover" 
                                    data-placement="left"
                                   
                                    style="color: firebrick; font-size: 25px"
                                >
                                    <i class="fas fa-trash-alt" data-review-id='${item._id}' onclick='remove_this_review(this)'></i>
                                </div>`
                                : ''
                            }
                        </div>
                        <h3>
                            ${item.review}
                        </h3>
                      ${html_reviews}
                        <div class="form-row">
                            ${render_comment(item.comments)}
                        </div>
                    </div>
                     ${html_expert} 
                </div>
            </li>
            ${i == 3 ? `
            <div class="text-center" style="
                margin-top: 20px;
            "><button class="btn btn-success text-center load-more-review">More reviews</button>
            </div>` : ``}
        `;
    })

    let content = `
        <ul class="list-group">
            ${html}
        </ul> 
    `;
    let item_title = _.size(data) ? `
        <div class="mr-1" style="font-size: 20px; font-weight: bold; display: inline">
            Reviews for ${data[0].menuItemName || data[0].name}
        </div> - <span style="font-style: italic">${_.size(data)} ${_.size(data) > 1 ? 'reviews' : 'review'} of this menu item</span>
        <div class="form-row">
            <div class="col-6">
                
            </div>
            <div class="col-6">
                <select id="reviews-of" class="form-control">
                </select>
            </div>
        <div>` 
        : '';
    let $this = $('#modal-item-reviews');
    $this.find('.modal-title').html(item_title);
    if(item_addons){
        let html = `<option value="all">All</option>`;
        _.forEach(item_addons, (item)=>{
            html+= `<option value="${item}">${item}</option>`
        })
        $this.find('#reviews-of').html(html);
    }
    $this.find('#reviews-of').on('change', function(){
        let val = $(this).val();
        $.each($this.find('.item-addons-review'), function(index, elem){
            if(val == 'all') return $(elem).show('slow');
            if(val == $(elem).data('name')){
                $('.load-more-review').parent().hide();
                $(elem).show('slow'); 
            } else{
                $(elem).hide();
            }
        })
    })
    $this.find('.modal-body').html(content || 'There are no reviews yet');
    $this.find('.remove-review-photo').popover({
        html: true,
        placement: 'bottom'
    })
    $this.find('.remove-this-review').popover({
        html: true,
        placement: 'left'
    })
    $this.modal().show();
    let myrate = false;
    $.each($this.find('.item-reviews-star'), function(index, elem) {
        let rating = $(elem).data('value')
        let ratedByUserId = $(elem).data('userid')
        if(user_id == ratedByUserId) myrate = true;
        else myrate = false;
        $(elem).rateYo({
            rating: rating,
            readOnly: true,
            starWidth: "30px",
            spacing: "5px",
            ratedFill: "green",
            normalFill: "#bdbcbc",
            starSvg: myrate ? __platerate_icons.my_heart_plate : __platerate_icons.heart_plate
        });
    })
    
    $('.load-more-review').on('click',function(){
        $(this).parent().hide();
        $this.find('.modal-body li.list-group-item').show();
    })
    $this.find('.my-expert-review').bootstrapSlider({
        min: 0,
        max: 100,
        tooltip: 'hide',
        formatter: function (value) {
            return;
        }
    });
}
